<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapDeliveryBillDetails"
        :table-action="true"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn"/>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="发货单号" prop="billNo">
            <el-input v-model="filter.billNo" clearable/>
          </el-form-item>
          <el-form-item label="销售单号" prop="billNo">
            <el-input v-model="filter.salesOrderNo" clearable/>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="filter.property" clearable placeholder="请选择订单类型">
              <el-option label="工控标准销售订单" :value="'ZGK1'"/>
              <el-option label="工控原材料销售订单" :value="'ZGK2'"/>
              <el-option label="赠送订单" :value="'ZF1'"/>
              <el-option label="寄售发货" :value="'ZJB'"/>
              <el-option label="寄售退回" :value="'ZJA'"/>
              <el-option label="寄售冲账" :value="'ZGJE'"/>
              <el-option label="借出订单" :value="'ZKB'"/>
              <el-option label="借出转销售订单" :value="'ZGK3'"/>
              <el-option label="借出试用冲帐（免费）" :value="'ZKM'"/>
              <el-option label="借出退回订单" :value="'ZKA'"/>
              <el-option label="贷项凭单请求" :value="'ZCR'"/>
              <el-option label="借项凭单请求" :value="'ZDR'"/>
              <el-option label="售后-换货订单" :value="'ZRCH'"/>
              <el-option label="标准退货订单" :value="'ZTRE'"/>
              <el-option label="工控原材料退货订单" :value="'ZT2'"/>
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="filter.status" clearable placeholder="请选择订单状态">
              <el-option label="草稿" :value="0"/>
              <el-option label="已提交" :value="10"/>
              <el-option label="已过账" :value="30"/>
              <el-option label="已签收" :value="50"/>
            </el-select>
          </el-form-item>
          <el-form-item label="交货日期">
            <el-date-picker
                v-model="deliveryDateRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                @change="dateRangeChange('deliveryDateRange', 'deliveryBeginDate', 'deliveryEndDate')"/>
          </el-form-item>
          <el-form-item label="记账日期">
            <el-date-picker
                v-model="createDateRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                @change="dateRangeChange('createDateRange', 'orderBeginDate', 'orderEndDate')"/>
          </el-form-item>
          <el-form-item label="提交日期">
            <el-date-picker
                v-model="submitDateRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                @change="dateRangeChange('submitDateRange', 'submitBeginDate', 'submitEndDate')"/>
          </el-form-item>
          <el-form-item label="签收日期">
            <el-date-picker
                v-model="signDateRange"
                type="deliveryDateRange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                @change="dateRangeChange('signDateRange', 'signBeginDate', 'signEndDate')"/>
          </el-form-item>
          <el-form-item label="销售单交货日期">
            <el-date-picker
                v-model="salesDeliveryDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('salesDeliveryDateRange', 'salesDeliveryBeginDate', 'salesDeliveryEndDate')"/>
          </el-form-item>
          <el-form-item label="物料编号" prop="materialNo">
            <el-input v-model="filter.materialNo" clearable/>
          </el-form-item>
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model="filter.materialName" clearable/>
          </el-form-item>
          <el-form-item label="规格型号" prop="specification">
            <el-input v-model="filter.specification" clearable/>
          </el-form-item>
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="filter.customerName" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <order-confirmation-record-edit
        :visible.sync="editVisible"
        :data="editData"
        @submit="submitHandle"
    />
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";

  export default {
    name: "DeliveryBillDetailList",
    components: { viewTable },
    data() {
      return {
        limits: {
          addAuth: false,
          editAuth: this.$auth(762),
          delAuth: this.$auth(763),
        },
        filter: {
          isEnd: "",
          productionNo: "",
          station: "",
          componentMaterialNo: "",
          componentBarcode: "",
          createIpAddress: "",
          endIpAddress: "",
          standardCode: "",
          procedureName: "",
          submitBeginDate: "",
          submitEndDate: "",
          signBeginDate: "",
          signEndDate: "",
          postBeginDate: "",
          postEndDate: "",
          orderBeginDate: "",
          orderEndDate: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          salesDeliveryBeginDate: "",
          salesDeliveryEndDate: "",
        },
        selection: [],
        submitDateRange: [],
        signDateRange: [],
        createDateRange: [],
        deliveryDateRange: [],
        salesDeliveryDateRange: [],
        editVisible: false,
        editData: {},
        columnsProperty: [
          {
            key: "deliveryBillNo", width: 160, align: "center" },
          {
            key: "salesOrderNo", width: 160, align: "center" },
          {
            key: "salesOrderCategoryName", width: 160, align: "center" },
          {
            key: "materialNo", width: 160, align: "center" },
          {
            key: "materialName", width: 160, align: "center" },
          {
            key: "mappingMaterialNo", width: 160, align: "center" },
          {
            key: "statusName", width: 150, align: "center"},
          {
            key: "specification", width: 150, align: "center"},
          {
            key: "manufacturerModel", width: 150, align: "center"},
          {
            key: "productLayer", width: 150, align: "center"},
          {
            key: "customerName", width: 200, align: "center"},
          {
            key: "contractNo", width: 150, align: "center"},
          {
            key: "customerContractNo", width: 150, align: "center"},
          {
            key: "postingLocalTime", width: 200, align: "center"},
          {
            key: "unitPrice", width: 100, align: "center"},
          {
            key: "totalAmount", width: 100, align: "center"},
          {
            key: "locationNo", width: 150, align: "center"},
          {
            key: "note", width: 150, align: "center" },
          // { key: "action", width: 150, align: "center", slot: "action" },
        ],
      };
    },
    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
      "filter.salesDeliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.salesDeliveryDateRange = [];
            this.salesDeliveryDateRange.push(this.filter.salesDeliveryBeginDate);
            this.salesDeliveryDateRange.push(this.filter.salesDeliveryEndDate);
          }
        },
      },
    },

    mounted() {
    },
    methods: {
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      selectHandle(selection) {
        this.selection = selection;
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "orderConfirmationRecords", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      resetHandle(filter) {
        this.filter = filter;
      },
      addEditHandle(row) {
        this.editData = row || {};
        this.editVisible = true;
      },
      submitHandle(form) {
        if (form.pkId) {
          // 编辑
          this.$http.put("basic", "orderConfirmationRecords", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("编辑成功");
            }
          });
        } else {
          // 新增
          this.$http.post("basic", "orderConfirmationRecords", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("新增成功");
            }
          });
        }
      },
    },
  };
</script>